import firebase from 'firebase/compat/app';

import STORE from 'store';

const invalidateMetricCache = async ({
  accountId,
  normalMetricIds,
  compoundMetricIds,
}: {
  accountId: string;
  normalMetricIds?: string[];
  compoundMetricIds?: string[];
}) => {
  const data: Record<string, unknown> = {
    updatedOn: firebase.firestore.FieldValue.serverTimestamp(),
  };
  if (normalMetricIds !== undefined) {
    data.normalMetricIds = normalMetricIds;
  }
  if (compoundMetricIds !== undefined) {
    data.compoundMetricIds = compoundMetricIds;
  }
  await STORE.metricDefinitions
    .getMetricCacheVersionRef({ accountId })
    .set(data);
};

export default invalidateMetricCache;
